export default {
    section1: {
        title: "Give your feedback for St Ives Improvement",
        paragraphs: [
            "Please share your views with us by completing this response form. The engagement starts 14th June and ends 5th July 5:00pm",
            "Contact us at: yourstives@cambridgeshirepeterborough-ca.gov.uk ",
            "If you would like to request a brochure please email exampleaddress@email.com or call freephone 01234 567 890 ",
            "Please view for a GDPR Statement: https://cambridgeshirepeterborough-ca.gov.uk/about-us/transparency/data-protection-policy/"
        ],
    },
    section2: {
        title: "Your St Ives Feedback Form",
        text: "If you’d prefer your comments to be anonymous, please just let us have your postcode (first five digits), so that we can understand where you live in relation to the scheme."
    },
    section3: {
        title: "The current St Ives Transport Network",
        question1: {
            title: "1. Which issues around St Ives are you most concerned about?",
            questions: [
                "Improve air quality",
                "Reduce traffic congestion",
                "Increase road safety",
                "Keep lorries away from residential areas",
                "Speed up journey times"
            ],
            answers: [
                "Strongly Agree",
                "Agree",
                "Disagree",
                "Strongly Disagree"
            ]
        },
        question2: {
            title: "2. Which do you think are a problem in your residential street or village?",
            questions: [
                "Commuters using road as a ‘rat run’",
                "Heavy lorries and vans taking a short cut ",
                "Vehicles speeding",
                "Traffic noise ",
                "Traffic fumes",
                "Heavy traffic",
                "Difficulty crossing road",
            ],
            answers: [
                "Strongly Agree",
                "Agree",
                "Disagree",
                "Strongly Disagree"
            ]
        },
        question3: {
            title: "3. How do you normally travel in your local neighbourhood?",
            questions: [
                { value: "Walking", textbox: false },
                { value: "Bicycle or e-bike", textbox: false },
                { value: "Bus, minibus, or coach", textbox: false },
                { value: "Motorcycle or moped", textbox: false },
                { value: "Lorry", textbox: false },
                { value: "Car/van (as driver)", textbox: false },
                { value: "Car/van (as passenger)", textbox: false },
                { value: "Taxi/minicab", textbox: false },
                { value: "Other", textbox: false },
            ]
        },
        question4: {
            title: "4. What is your special interest in the road network around huntingdon and St Ives? (Please tick all that apply)",
            questions: [
                { value: "Resident of St Ives, Houghton, Needingworth, etc.", textbox: false },
                { value: "Resident and local business owner", textbox: false },
                { value: "Local business owner", textbox: false },
                { value: "Freight delivery to the area", textbox: false },
                { value: "Commercial ‘through’ driver", textbox: false },
                { value: "Commuter by car", textbox: false },
                { value: "Taxi or minicab driver", textbox: false },
                { value: "Bus or coach driver", textbox: false },
                { value: "Commuter by bike", textbox: false },
                { value: "Commuter by foot", textbox: false },
                { value: "Commuter by motorbike, moped or scooter", textbox: false },
                { value: "Leisure cyclist", textbox: false },
                { value: "Leisure walker", textbox: false },
                { value: "Other", textbox: false },
            ]
        }
    },
    section4: {
        title: 'Future St Ives Transport Network',
        question1: {
            title: "5. Do you agree there is a need to reduce road traffic (cars, lorries, vans) in St Ives?",
            questions: [
                { value: "Strongly Agree", textbox: false },
                { value: "Agree", textbox: false },
                { value: "Don’t Know", textbox: false },
                { value: "Disagree", textbox: false },
                { value: "Strongly Disagree", textbox: false },
            ]
        },
        question2: {
            title: "6. To what extent do you agree there is a need to make travel by public transport easier in St Ives (bus, coach, taxi or minibus)?",
            questions: [
                "Dedicated bus and coach lane",
                "Dedicated minbus/taxi/minicab lane",
            ],
            answers: [
                "Strongly Agree",
                "Agree",
                "Disagree",
                "Strongly Disagree"
            ]
        },
        question3: {
            title: "7. To what extent do you agree there is a need to allocate road space for non-motorised users (walkers, cyclists and horse riders)?",
            question: [
                "More dedicated walking space",
                "More dedicated cycling space",
                "More dedicated bridle paths"
            ],
            answers: [
                "Strongly Agree",
                "Agree",
                "Disagree",
                "Strongly Disagree"
            ]
        },
        question4: {
            title: "8. What matters to you in the future development of your local transport network?",
            question: [
                "Address congestion and delay on existing road network within St. Ives",
                "Reduce journey times on local routes caused by hold-ups",
                "Create better connected public transport",
                "Safeguard residential streets and villages and from ‘rat-runs’",
                "Cut carbon emissions from traffic jams",
                "Improve road safety",
                "Increase travel options for local people",
                "Ensure local transport keeps your area linked into growth opportunity – jobs, homes, investment"
            ],
            answers: [
                "Not Important",
                "Very Important",
                "Not Applicable (N/A)",
            ]
        },
        question5: {
            title: "9. What improvements would you like to see in the local area to encourage wider active travel.",
            text: "(Drop a maximum of 5 pin points on the map by clicking on the edit pinpoints button below and using the add/delete buttons at the top right of the map, to highlight where you would like these to be considered further.)"
        }
    },
    section5: {
        title: 'Options',
        question1: {
            title: 'Choice 1 (favourite)',
            options: [
                { value: 'Option 1 – Offline Bypass from the A141 around the north of St Ives to the A1123 to the east of St Ives.' },
                { value: 'Option 2 – Offline bypass from the A141 around the north of St Ives, connecting to an upgraded Marley Road.' },
                { value: 'Option 3 - Offline Bypass from the A141 around the north of St Ives, connecting to an upgraded Marley Road. From the B1040, an offline link would be provided to connect the B1040 to the A1123.' },
                { value: 'Option 4 – Local Junction Improvement Package.' },
                { value: 'Option 5 – Sustainable Travel Package.' },
                { value: 'Option 6 – Non-Motorised User Package.' },
            ]
        },
        question2: {
            title: 'Choice 2',
            options: [
                { value: 'Option 1 – Offline Bypass from the A141 around the north of St Ives to the A1123 to the east of St Ives.' },
                { value: 'Option 2 – Offline bypass from the A141 around the north of St Ives, connecting to an upgraded Marley Road.' },
                { value: 'Option 3 - Offline Bypass from the A141 around the north of St Ives, connecting to an upgraded Marley Road. From the B1040, an offline link would be provided to connect the B1040 to the A1123.' },
                { value: 'Option 4 – Local Junction Improvement Package.' },
                { value: 'Option 5 – Sustainable Travel Package.' },
                { value: 'Option 6 – Non-Motorised User Package.' },
            ]
        },
        question3: {
            title: 'Choice 3',
            options: [
                { value: 'Option 1 – Offline Bypass from the A141 around the north of St Ives to the A1123 to the east of St Ives.' },
                { value: 'Option 2 – Offline bypass from the A141 around the north of St Ives, connecting to an upgraded Marley Road.' },
                { value: 'Option 3 - Offline Bypass from the A141 around the north of St Ives, connecting to an upgraded Marley Road. From the B1040, an offline link would be provided to connect the B1040 to the A1123.' },
                { value: 'Option 4 – Local Junction Improvement Package.' },
                { value: 'Option 5 – Sustainable Travel Package.' },
                { value: 'Option 6 – Non-Motorised User Package.' },
            ]
        },
        question4: {
            title: '11.	Which combination of the option elements would you prefer to see considered further? Please choose a maximum of five combinations from the options below.',
            questions: [
                { value: "Option 1 and 4" },
                { value: "Option 1 and 5" },
                { value: "Option 1 and 6" },
                { value: "Option 2 and 4" },
                { value: "Option 2 and 5" },
                { value: "Option 2 and 6" },
                { value: "Option 3 and 4" },
                { value: "Option 3 and 5" },
                { value: "Option 3 and 6" },
                { value: "Option 4 and 5" },
                { value: "Option 4 and 6" },
                { value: "Option 5 and 6" },
            ]
        },
        question5: {
            title: 'Do you have any other comments that haven’t been captured?'
        }
    },
    section6: {
        title: "Thank you!",
        text: 'Your feedback has succesfully been submitted, we will be in touch with further details once available.'
    }
}